import { Tool } from '@procureai/agents';
import { useTranslation } from 'react-i18next';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { SvbrgQuoteComparatorInput, SvbrgQuoteComparatorOutput } from '@/generated/gql/graphql';
import { I18nNamespace } from '@/legacy/common/types';

import { ToolResultComponent } from '.';
import { QuoteComparisonResult } from './QuoteComparisonResult';

export const QuoteComparisonTool: ToolResultComponent<
  Tool.quoteComparator,
  SvbrgQuoteComparatorInput,
  SvbrgQuoteComparatorOutput
> = ({ tool, toolName }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${toolName}` });

  switch (tool.state) {
    case 'input-streaming':
    case 'input-available':
      return <ChatLoadingIndicator message={t(`call`, { count: tool.input?.fileIds.length ?? 0 })} />;

    case 'output-available':
      return <QuoteComparisonResult result={tool.output} />;
  }
};
